/* LGND global behaviors — scroll-reveal (safe), smooth anchors */
(function () {
  'use strict';

  // Bail completely if reduced motion is requested
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  function init() {
    // Only animate sections in the main content area (skip header/footer groups)
    var sections = document.querySelectorAll(
      '#MainContent > .shopify-section, main .shopify-section'
    );

    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lgnd-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -10% 0px' }
    );

    // For each section, decide whether to animate or skip
    // Skip if it's already partially in view (top is above viewport bottom).
    sections.forEach(function (section, index) {
      // Always show the first section (hero) instantly
      if (index === 0) {
        section.classList.add('lgnd-in-view');
        return;
      }

      var rect = section.getBoundingClientRect();
      var inView = rect.top < window.innerHeight - 80;

      if (inView) {
        // Already visible at page load — show without animation
        section.classList.add('lgnd-in-view');
      } else {
        // Prep for reveal animation, then observe
        section.classList.add('lgnd-prep');
        observer.observe(section);
      }
    });

    // Smooth-scroll for in-page anchor links
    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
